// Photos inside the product card (snippets/product-card.liquid): up to four
// photos in a scroll-snapped track, and a pill at their foot with the
// previous arrow, one dot per photo and the next arrow. The swipe is the
// platform's own scroll, where the listing lets the track scroll (grids); in
// the rails the track takes no swipe, so the rail keeps its own, and the
// pill moves the photos: the arrows one by one, a dot straight to its photo.
// Nothing runs on load beyond binding the listeners: the dots follow the
// scroll position.

const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

class CardGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-card-track]');
    this.dots = Array.from(this.querySelectorAll('.card__dot'));
    if (!this.track || this.dots.length < 2) return;

    this.controller = new AbortController();
    const { signal } = this.controller;

    this.track.addEventListener('scroll', () => this.sync(), { passive: true, signal });

    // The two arrows of the pill walk the photos and wrap at both ends.
    this.querySelector('[data-card-next]')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.go(this.index() + 1);
    }, { signal });
    this.querySelector('[data-card-prev]')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.go(this.index() - 1);
    }, { signal });
    this.dots.forEach((dot, position) => dot.addEventListener('click', (event) => {
      event.preventDefault();
      this.go(position);
    }, { signal }));
  }

  go(index) {
    const total = this.dots.length;
    const target = ((index % total) + total) % total;
    this.track.scrollTo({
      left: target * this.track.clientWidth,
      behavior: reduceMotion() ? 'auto' : 'smooth',
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  index() {
    return Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
  }

  sync() {
    const current = this.index();
    this.dots.forEach((dot, position) => {
      dot.toggleAttribute('data-active', position === current);
      if (position === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('card-gallery')) {
  customElements.define('card-gallery', CardGallery);
}
